import { useState } from "react";
import { Copy, CreditCard, Landmark, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT") : "");

export const PaymentBlock = ({ c, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  const link = c.pay_token ? `${window.location.origin}/training-online/iscrizione/${c.pay_token}` : "";

  const invite = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/coaching-checkups/${c.id}/invite`, { origin_url: window.location.origin });
      onUpdated(c, { pay_status: "invitato", pay_token: data.link.split("/").pop(), invited_at: data.invited_at, invite_email_status: data.invite_email_status });
      toast[data.invite_email_status === "sent" ? "success" : "error"](data.invite_email_status === "sent" ? "Link di pagamento inviato" : "Link creato, ma la mail non è partita: copialo e invialo tu");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  const markPaid = async () => {
    if (!window.confirm(`Confermi di aver ricevuto il bonifico di ${c.name}?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/coaching-checkups/${c.id}/mark-paid`);
      onUpdated(c, { pay_status: data.pay_status, paid_at: data.paid_at, status: "cliente" });
      toast.success("Segnato come pagato: email di conferma inviata");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Link copiato");
    } catch {
      toast.error("Copia non riuscita");
    }
  };

  if (c.pay_status === "pagato") {
    return (
      <p data-testid={`coaching-paid-badge-${c.id}`} className="mt-3 inline-flex items-center gap-2 bg-[#98bfa2] px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-[#050807]">
        <CreditCard size={13} /> Pagato {c.pay_amount ?? 497} € · {fmt(c.paid_at)}
      </p>
    );
  }
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid={`coaching-payment-${c.id}`}>
      <button type="button" data-testid={`coaching-invite-btn-${c.id}`} onClick={invite} disabled={busy}
        className="inline-flex items-center gap-2 bg-[#98bfa2] px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-[#050807] hover:bg-[#c4dcca] disabled:opacity-50">
        <Send size={13} /> {busy ? "Invio…" : c.pay_status === "invitato" ? "Reinvia link pagamento" : "Accetta e invia link pagamento"}
      </button>
      {link && (
        <button type="button" data-testid={`coaching-copy-link-${c.id}`} onClick={copy}
          className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]">
          <Copy size={13} /> Copia link
        </button>
      )}
      {c.invited_at && <span className="font-mono text-[11px] text-[#a3b1aa]">Inviato il {fmt(c.invited_at)} · {c.pay_status === "bonifico_in_attesa" ? `ha scelto il bonifico${c.bank_reminder_sent_at ? ` · promemoria inviato il ${fmt(c.bank_reminder_sent_at)}` : ""}` : "in attesa di pagamento"}</span>}
      {c.pay_token && (
        <button type="button" data-testid={`coaching-mark-paid-btn-${c.id}`} onClick={markPaid} disabled={busy}
          className="inline-flex items-center gap-2 border border-[#98bfa2] px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-[#c4dcca] hover:bg-[#98bfa2] hover:text-[#050807] disabled:opacity-50">
          <Landmark size={13} /> Bonifico ricevuto
        </button>
      )}
    </div>
  );
};
